import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import './Requests.less';

import RequestsList from './Requests';
import ViewRequest from './ViewRequest';

function PropertiesPage(props) {
  const {
    match: { url }
  } = props;

  return (
    <Switch>
      <Route exact path={`${url}/`} component={RequestsList} />
      <Route path={`${url}/:id/`} component={ViewRequest} />
    </Switch>
  );
}

PropertiesPage.propTypes = {
  match: PropTypes.object
};

export default PropertiesPage;
